module.exports = __webpack_public_path__ + "static/media/level3-3c.64148646.mp3";